import { TOGGLE_FOCUS_MODE } from '../ui/actionTypes'
const INITIAL_STATE = {
  query: '',
  isActive: false,
  isInFullText: false,
  highlightedIndex: 0,
  navigatingFullTextSearch: false,
}

// SELECTORS
export function getSearchState(state) {
  return state.search
}

// ACTIONS
export function setQuery(query) {
  return {
    type: 'SEARCH/SET_QUERY',
    payload: {
      query,
    },
  }
}

export function activate() {
  return {
    type: 'SEARCH/ACTIVATE',
  }
}

export function clear() {
  return {
    type: 'SEARCH/CLEAR',
  }
}

export function exit() {
  return {
    type: 'SEARCH/EXIT',
  }
}

export function switchToFullText({ query } = {}) {
  return {
    type: 'SEARCH/SWITCH_TO_FULL_TEXT',
    payload: query,
  }
}

export function setHighlightedIndex(index) {
  return {
    type: 'SEARCH/SET_HIGHLIGTHED_INDEX',
    payload: {
      index,
    },
  }
}

export function setNavigatingInFullTextSearch(navigatingFullTextSearch) {
  return {
    type: 'SEARCH/SET_NAVIGATING_FULL_TEXT_SEARCH',
    payload: {
      navigatingFullTextSearch,
    },
  }
}

// REDUCER
export default function reducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case 'SEARCH/SET_QUERY': {
      return {
        ...state,
        isActive: true,
        query: action.payload.query,
        highlightedIndex: 0,
      }
    }

    case 'SEARCH/ACTIVATE': {
      return {
        ...INITIAL_STATE,
        isActive: true,
      }
    }

    case 'SEARCH/CLEAR': {
      return {
        ...state,
        query: '',
        isInFullText: false,
        highlightedIndex: 0,
      }
    }

    case TOGGLE_FOCUS_MODE:
    case 'SEARCH/EXIT': {
      return INITIAL_STATE
    }

    case 'SEARCH/SWITCH_TO_FULL_TEXT': {
      return {
        ...state,
        isInFullText: true,
        highlightedIndex: 0,
        query: action.payload || state.query,
      }
    }

    case 'SEARCH/SET_HIGHLIGTHED_INDEX': {
      return {
        ...state,
        highlightedIndex: action.payload.index,
      }
    }

    case 'SEARCH/SET_NAVIGATING_FULL_TEXT_SEARCH': {
      return {
        ...state,
        navigatingFullTextSearch: action.payload.navigatingFullTextSearch,
      }
    }

    default: {
      return state
    }
  }
}
